import { WEB_COMPONENT_PACKAGE_USE_PROXY_FORM } from '../../../webcomponents.constants';
import { PackageUseProxyFormWebComponent } from './component/PackageUseProxyFormWebComponent';

export { PackageUseProxyFormWebComponent };

window.customElements.define(WEB_COMPONENT_PACKAGE_USE_PROXY_FORM, PackageUseProxyFormWebComponent);
